import { render, staticRenderFns } from "./ManageVideoFilesMenu.vue?vue&type=template&id=18ff0b18&"
import script from "./ManageVideoFilesMenu.vue?vue&type=script&lang=ts&"
export * from "./ManageVideoFilesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ManageVideoFilesMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports